var map = {
	"./data-search.de-CH.json": 908,
	"./data-search.de-DE.json": 909,
	"./data-search.en-CA.json": 910,
	"./data-search.en-GB.json": 911,
	"./data-search.en-IN.json": 912,
	"./data-search.en-ME.json": 913,
	"./data-search.en-US.json": 914,
	"./data-search.es-EM.json": 915,
	"./data-search.es-ES.json": 916,
	"./data-search.fr-BE.json": 917,
	"./data-search.fr-CA.json": 918,
	"./data-search.fr-CH.json": 919,
	"./data-search.nl-BE.json": 920,
	"./data-search.nl-NL.json": 921,
	"./data-search.pl-PL.json": 922,
	"./data-search.pt-BR.json": 923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;